var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { active: _vm.isActive },
      style: _vm.paragraphMargins,
      attrs: { id: "FormParagraph" },
      on: { click: _vm.handleClick },
    },
    [
      _c(
        "div",
        { staticClass: "form-paragraph" },
        [
          _c("quill-editor", {
            ref: "quillEditor",
            staticClass: "paragraph-quill-editor",
            attrs: { options: _vm.editorOptions },
            on: { change: _vm.onEditorChange, blur: _vm.onEditorBlur },
            model: {
              value: _vm.localContent,
              callback: function ($$v) {
                _vm.localContent = $$v
              },
              expression: "localContent",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }